/** Display labels for claim contact types — shared by the claim contacts panel and email composer. */
export function formatContactType(type: string): string {
  const labels: Record<string, string> = {
    claimant:            "Claimant",
    contractor:          "Contractor",
    carrier:             "Carrier",
    attorney:            "Attorney",
    engineer:            "Engineer",
    building_consultant: "Building Consultant",
    appraiser:           "Appraiser",
    umpire:              "Umpire",
    field_adjuster:      "Field Adjuster",
    desk_adjuster:       "Desk Adjuster",
    other:               "Other",
  };
  return labels[type] ?? type;
}
